export default "__VITE_ASSET__6965c3f7__"